/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlmBomOutgoingItemResponseDto>
>;
export function request(
  params: API.basics.plmProductBomOutgoingItem.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/plmBomOutgoingItem/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
